<div class="fullscreen" (mouseenter)="onHoverHandler('isButtonsShown', true)" (mouseleave)="onHoverHandler('isButtonsShown', false)">
  <div class="top-info-panel">
    <div class="info-back-wrapper">
      <mat-icon (click)="closeFnc()">arrow_back</mat-icon>
      <span class="address">{{ status.address }}</span>
    </div>
    <button (click)="viewImageOnMap()" class="view-on-map-button toolTipButton" [disabled]="!this.obliqueAvailable">
      <span *ngIf="!this.obliqueAvailable" class="tooltiptext">Not able to view on map with this collection</span>
      <mat-icon>map</mat-icon>
      View on map
    </button>
  </div>
  <div class="fullscreen-image">
    <span
      *ngIf="isButtonsShown"
      class="side-column align-right"
      (click)="totalAmount > 1 ? prev() : null"
      [class.disabled]="totalAmount <= 1"
      (mouseenter)="onHoverHandler('isArrowLabelShown.prev', true)"
      (mouseleave)="onHoverHandler('isArrowLabelShown.prev', false)">
      <mat-icon>navigate_before</mat-icon>
      <span *ngIf="isArrowLabelShown.prev" class="arrow-label">Previous</span>
    </span>
    <div class="img-wrapper">
      <div class="image" id="full-image-wrapper">
        <div *ngIf="isLoading" class="image-mask">
          <app-loading [show]="true"></app-loading>
        </div>
        <custom-gallery-image [src]="image.fullScreenTileURl" [className]="'full-screen'" (loadEvent)="hideLoader()" id="full-image"></custom-gallery-image>
      </div>
    </div>
    <span
      *ngIf="isButtonsShown"
      class="side-column align-left"
      (click)="totalAmount > 1 ? next() : null"
      [class.disabled]="totalAmount <= 1"
      (mouseenter)="onHoverHandler('isArrowLabelShown.next', true)"
      (mouseleave)="onHoverHandler('isArrowLabelShown.next', false)">
      <mat-icon>navigate_next</mat-icon>
      <span *ngIf="isArrowLabelShown.next" class="arrow-label">Next</span>
    </span>
  </div>
  <div class="bottom-info-panel">
    <div class="image-info-wrapper">
      <span>
        {{ image.original_image_name }}
      </span>
      <ng-template #longerNameBlock>
        <span matTooltip="{{ image.original_image_name }}">{{ shortName }}</span>
      </ng-template>
      <span>{{ captureDate }}</span>
      <span class="image-gsd-type">{{ type }}</span>
    </div>
    <div class="bottom-actions-panel">
      <span class="count">{{ serialNumber + 1 }}/{{ totalAmount }}</span>
      <button matIconButton (click)="handleImageInfo(!isInfoShown)" matTooltip="Image details">
        <mat-icon>info</mat-icon>
      </button>
      <button matIconButton (click)="downloadResource(image.fullScreenTileURl, image.original_image_name)" matTooltip="Download">
        <mat-icon>photo_camera</mat-icon>
      </button>
    </div>
  </div>
</div>
<lib-fullscreen-info
  *ngIf="isInfoShown"
  [image]="image"
  [captureDate]="captureDate"
  [mapCenterCoordinates]="mapCenterCoordinates"
  (closeInfo)="handleImageInfo(false)"
  [shortName]="shortName"></lib-fullscreen-info>
